import type {MetricsResponse} from 'common/react-query/metrics/types';

export const COLORS = [
  `#7856FF`,
  `#FF7557`,
  `#80E1D9`,
  `#F8BC3B`,
  `#B2586E`,
  `#72BEF4`,
  `#FFB27A`,
  `#0D7EA0`,
  `#3BA974`,
  `#FEBBB2`,
];

function compute(sourceData: number[], targetData: number[]): number {
  // Truncate both datasets to the length of the smaller one
  const minLength = Math.min(sourceData.length, targetData.length);
  const sanitizedSourceData = sourceData.slice(0, minLength);
  const sanitizedTargetData = targetData.slice(0, minLength);

  const n = sanitizedSourceData.length;

  const sourceDataSum = sanitizedSourceData.reduce((acc, val) => acc + val, 0);
  const targetDataSum = sanitizedTargetData.reduce((acc, val) => acc + val, 0);

  const sourceDataSqr = sanitizedSourceData.reduce((acc, val) => acc + val * val, 0);
  const targetDataSqr = sanitizedTargetData.reduce((acc, val) => acc + val * val, 0);

  const sumProducts = sanitizedSourceData.reduce((acc, val, idx) => acc + val * sanitizedTargetData[idx], 0);

  const numerator = n * sumProducts - sourceDataSum * targetDataSum;
  const denominator = Math.sqrt(
    (n * sourceDataSqr - sourceDataSum * sourceDataSum) * (n * targetDataSqr - targetDataSum * targetDataSum),
  );

  if (denominator === 0) return 0; // Handle division by zero in case of no variance

  return numerator / denominator;
}

export function getCorrelationScore(
  sourceNodeResults: MetricsResponse | null,
  targetNodeResults: MetricsResponse | null,
): number | null {
  if (sourceNodeResults && targetNodeResults) {
    return compute(sourceNodeResults.timeseries, targetNodeResults.timeseries);
  }
  return null;
}

export function hasResults(results: MetricsResponse) {
  return results && results.timeseries.length > 0;
}
